export default __webpack_public_path__ + "static/media/coupleImg.9df1c1b3.png";